import {match} from 'ts-pattern';

const PERCENT_FACTOR = 100;

/**
 * Period-over-period delta in whole percent (per spec).
 * - `null`  → the value is new this period (no previous baseline, current > 0)
 * - `0`     → no previous baseline and nothing this period either
 * - number  → rounded percentage change vs. the previous window
 */
export const calculateDelta = (count: number, previousCount: number): number | null =>
  match(previousCount)
    .with(0, () => (count > 0 ? null : 0))
    .otherwise((previous) => Math.round(((count - previous) / previous) * PERCENT_FACTOR));
